import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import ProjectGallery from "@/components/ProjectGallery";
import ProjectTabs from "@/components/ProjectTabs";

export default function Gallery() {
  const { id } = useParams();
  const [projects, setProjects] = useState([]);
  const [selected, setSelected] = useState(id || "");

  useEffect(() => {
    if (!id) api.get("/projects").then(({ data }) => {
      const rows = Array.isArray(data) ? data : data.items || [];
      setProjects(rows);
      if (rows.length && !selected) setSelected(rows[0].id);
    });
  }, [id]); // eslint-disable-line

  const projectId = id || selected;
  const current = projects.find((p) => p.id === selected);

  return (
    <div data-testid="gallery-page">
      <PageHeader title="Galería de Fotos" subtitle={id ? "Fotos de la obra" : "Avance fotográfico por obra"} testId="gallery-header" />
      <div className="px-6 lg:px-8 py-6 space-y-4">
        {id ? (
          <ProjectTabs projectId={id} active="gallery" />
        ) : (
          <div className="panel p-3 max-w-md">
            <label className="label-mono block mb-1.5">Obra</label>
            <select value={selected} onChange={(e) => setSelected(e.target.value)} data-testid="gallery-project-select"
              className="w-full input-cyber px-3 py-2 text-sm">
              {projects.map((p) => <option key={p.id} value={p.id}>{p.code} — {p.name}</option>)}
            </select>
            {current && <div className="text-[10px] text-slate-500 mt-1.5">{current.client}</div>}
          </div>
        )}
        {projectId ? <ProjectGallery projectId={projectId} /> : (
          <div className="panel p-10 text-center text-slate-500 text-sm" data-testid="gallery-no-projects">
            No tienes obras asignadas todavía. Pide al administrador que te asigne una obra, o entra a la galería desde el detalle de la obra.
          </div>
        )}
      </div>
    </div>
  );
}
